import React, { createContext, useContext, useState } from "react";

export const ApplicationContext = createContext();

export const useApplicationContext = () => useContext(ApplicationContext);

export const ApplicationProvider = ({ children }) => {
  const [applicationType, setApplicationType] = useState("inicial");
  return (
    <ApplicationContext.Provider
      value={{
        applicationType,
        setApplicationType,
      }}
    >
      {children}
    </ApplicationContext.Provider>
  );
};
